import React from 'react';
import { ICreateData } from './shared';
import EmptyInfo from './types/emptyInfo';
import Timeline from './types/timeline';
import EventRatesOT from '@pages-clean/admin/study/manage-panels/tab-content/panel-details/types/eventRatesOT';
import ProportionsOT from '@pages-clean/admin/study/manage-panels/tab-content/panel-details/types/proportionsOT';
import TriOpDate from '@pages-clean/admin/study/manage-panels/tab-content/panel-details/types/tri-op-date';
import { PanelModelType, PanelType } from 'types/graphql-global-types';
import { useTranslation } from '@hooks/index';

interface IProps {
    createData?: ICreateData;
    panel?: {
        id: string;
        type: PanelType;
        modelType?: PanelModelType;
    };
    canEdit?: boolean;
}
const PanelDetails = ({ createData, panel, canEdit }: IProps) => {
    const { t } = useTranslation('admin', { keyPrefix: 'managePanels.panelDetails' });

    if (!createData && !panel) {
        return <EmptyInfo message={t('empty.noPanelSelected')} />;
    }

    if (createData?.type === 'Timeline' || panel?.type === 'TIMELINE') {
        return <Timeline panelRef={panel?.id} createData={createData} canEdit={canEdit} />;
    }

    if (createData?.type === 'TRI Ops-Date' || panel?.type === PanelType.TRI_OP_DATE) {
        return <TriOpDate panelRef={panel?.id} createData={createData} canEdit={canEdit} />;
    }

    if (createData?.type === 'Proportions OT' || panel?.type === PanelType.PROPORTIONS_OVER_TIME) {
        return <ProportionsOT panelRef={panel?.id} createData={createData} canEdit={canEdit} />;
    }

    if (createData?.type === 'Event Rates OT' || panel?.type === PanelType.EVENT_RATES_OVER_TIME) {
        return <EventRatesOT panelRef={panel?.id} createData={createData} canEdit={canEdit} />;
    }

    return (
        <div className="k-h-full">
            <EmptyInfo message={t('empty.underConstruction')} />
        </div>
    );
};

export default PanelDetails;
